import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";

import { UniAccordionComponent } from "../accordion.component";

@Component({
  selector: "uni-accordion-group",
  templateUrl: "./accordion-group.component.html",
  styleUrls: ["./accordion-group.component.scss"],
})
export class UniAccordionGroupComponent implements OnInit {
  /** the title of the group */
  @Input() public heading: string;

  /** if `true` the group will has edit button */
  @Input() public icon: boolean = false;

  /**@ignore */
  public isChild: boolean = false;

  /**@ignore */
  public showExpandedIcon: boolean;

  /** if `true` the group will expand. By default is exapended unless if is child */
  @Input() public isExpanded: boolean;

  /** Emits when the expanded state changes */
  @Output() public isExpandedChange = new EventEmitter<boolean>();

  /**@ignore */
  @ViewChild("title", { static: true }) public title: TemplateRef<unknown>;

  /**@ignore */
  @ViewChild("content", { static: true }) public content: TemplateRef<unknown>;

  constructor(private uniAccordion: UniAccordionComponent) {}

  public ngOnInit(): void {
    this.isChild = this.uniAccordion.isChild;
    this.isExpanded = this.isExpanded ?? !this.isChild;

    this.showExpandedIcon = this.uniAccordion.showExpandedIcon;
  }

  public onExpand(expanded: boolean): void {
    this.isExpanded = expanded;
    this.isExpandedChange.emit(expanded);
  }
}
